export const BILLING_MODAL = 'billing'
export const CREATE_STUDENT_MODAL = 'create_student_modal'
export const SUBSCRIBE_MODAL = 'subscribe'
export const ADD_REPORT_CARDS_MODAL = 'add_report_cards'
export const PROMPT_MODAL = 'prompt'
export const MESSAGE_MODAL = 'message'
